export default "__VITE_ASSET__ce248049__"